var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 82,
    viewBox: "0 0 60 82",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 82,
    rx: 5.85714,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2414 39V16.12L11.8414 19.44V13.44L17.2414 10.2H22.8014V39H17.2414ZM37.0855 39.6C34.9521 39.6 33.0855 39.1533 31.4855 38.26C29.8855 37.3667 28.6388 36.12 27.7455 34.52C26.8521 32.92 26.4055 31.0533 26.4055 28.92V20.28C26.4055 18.1467 26.8521 16.28 27.7455 14.68C28.6388 13.08 29.8855 11.8333 31.4855 10.94C33.0855 10.0467 34.9521 9.6 37.0855 9.6C39.2188 9.6 41.0855 10.0467 42.6855 10.94C44.2855 11.8333 45.5321 13.08 46.4255 14.68C47.3188 16.28 47.7655 18.1467 47.7655 20.28V28.92C47.7655 31.0533 47.3188 32.92 46.4255 34.52C45.5321 36.12 44.2855 37.3667 42.6855 38.26C41.0855 39.1533 39.2188 39.6 37.0855 39.6ZM37.0855 34.44C38.0455 34.44 38.9121 34.2133 39.6855 33.76C40.4588 33.3067 41.0721 32.6933 41.5255 31.92C41.9788 31.1467 42.2055 30.28 42.2055 29.32V19.84C42.2055 18.88 41.9788 18.0133 41.5255 17.24C41.0721 16.4667 40.4588 15.8533 39.6855 15.4C38.9121 14.9467 38.0455 14.72 37.0855 14.72C36.1255 14.72 35.2588 14.9467 34.4855 15.4C33.7121 15.8533 33.0988 16.4667 32.6455 17.24C32.1921 18.0133 31.9655 18.88 31.9655 19.84V29.32C31.9655 30.28 32.1921 31.1467 32.6455 31.92C33.0988 32.6933 33.7121 33.3067 34.4855 33.76C35.2588 34.2133 36.1255 34.44 37.0855 34.44Z",
    fill: "#EB3000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9998 51.0059C25.5612 43.2841 14.25 46.3057 14.25 53.8932C14.25 62.4208 25.9908 65.4424 29.9282 73.3657L29.9998 73.5L30.0714 73.3657C34.0089 65.4424 45.7497 62.4208 45.7497 53.8932C45.8213 46.3057 34.4384 43.2841 29.9998 51.0059Z",
    fill: "#EB3000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTh);
export default __webpack_public_path__ + "static/media/th.57ed00e2fc9e870093d9511c27b3f447.svg";
export { ForwardRef as ReactComponent };